import ReactDOM from 'react-dom';
import routes from '../routes';

ReactDOM.render((routes), document.getElementById('reactContent'));

// todo - switch to using the below. This will cause the leave without saving warning system to become unstable and occasionally break tests (by showing the warning modal when it shouldn't). We will probably need to replace the leave without saving part of the system entirely. Doing that may mean upgrading react-router to v6 and changing the routing approach (so we can use useBlocker).
// import ReactDOM from 'react-dom/client';
// import routes from '../routes';
//
// const root = ReactDOM.createRoot(document.getElementById("reactContent"));
// root.render(routes);
